import { FaExternalLinkAlt, FaInfoCircle } from 'react-icons/fa';

/**
 * SourceAttribution Component
 *
 * Displays source attribution for prompts that were collected/scraped from public sources.
 * Shows platform, author, and link to original source with proper credit.
 */
const SourceAttribution = ({ prompt }) => {
  // Don't render if no source attribution
  if (!prompt.source_platform && !prompt.source_attribution) {
    return null;
  }

  return (
    <div className="bg-gray-50 border border-gray-200 rounded-lg p-4 mb-6">
      <div className="flex items-start gap-3">
        <FaInfoCircle className="text-gray-400 mt-1 flex-shrink-0" />
        <div className="flex-1">
          <p className="text-sm text-gray-700 mb-2">
            <span className="font-semibold">Source: </span>
            {prompt.source_attribution || `From ${prompt.source_platform}`}
          </p>

          {prompt.source_url && (
            <a
              href={prompt.source_url}
              target="_blank"
              rel="noopener noreferrer"
              className="inline-flex items-center gap-2 text-sm text-boop-primary hover:text-boop-secondary transition-colors"
            >
              View original source
              <FaExternalLinkAlt className="text-xs" />
            </a>
          )}
        </div>
      </div>
    </div>
  );
};

export default SourceAttribution;
